import { useState, useMemo, useCallback } from 'react';
import { MOCK_COURSES, MOCK_PROVIDERS } from '../mockData';

const useCatalogState = () => {
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [selectedCategorySlug, setSelectedCategorySlug] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [sortAsc, setSortAsc] = useState(false);

  const categories = useMemo(() => {
    const categoryMap = new Map();
    MOCK_COURSES.forEach((course) => {
      if (course.categories) {
        course.categories.forEach((cat) => {
          if (!categoryMap.has(cat.slug)) {
            categoryMap.set(cat.slug, cat);
          }
        });
      }
    });
    return Array.from(categoryMap.values());
  }, []);

  const filteredCourses = useMemo(() => {
    let filtered = MOCK_COURSES;
    if (selectedProviderId) {
      filtered = filtered.filter((c) => c.ownerSlug === selectedProviderId);
    }
    if (selectedCategorySlug) {
      filtered = filtered.filter((c) => c.categories?.some((cat) => cat.slug === selectedCategorySlug));
    }
    return [...filtered].sort((a, b) => (sortAsc ? a.price.gross - b.price.gross : b.price.gross - a.price.gross));
  }, [selectedProviderId, selectedCategorySlug, sortAsc]);

  const selectedIds = useMemo(() => new Set(selectedCourses.map((c) => c.id)), [selectedCourses]);

  const handleToggle = useCallback((course) => {
    setSelectedCourses((prev) => {
      const exists = prev.find((c) => c.id === course.id);
      if (exists) return prev.filter((c) => c.id !== course.id);
      return [...prev, course];
    });
  }, []);

  const handleRemove = useCallback((courseId) => {
    setSelectedCourses((prev) => prev.filter((c) => c.id !== courseId));
  }, []);

  const handleClear = useCallback(() => {
    setSelectedCourses([]);
  }, []);

  const toggleSort = useCallback(() => {
    setSortAsc((prev) => !prev);
  }, []);

  const currency = selectedCourses[0]?.currency || MOCK_COURSES[0]?.currency || 'SEK';

  return {
    // Filter state
    categories,
    providers: MOCK_PROVIDERS,
    selectedProviderId,
    setSelectedProviderId,
    selectedCategorySlug,
    setSelectedCategorySlug,
    // Course list
    filteredCourses,
    // Selection
    selectedCourses,
    selectedIds,
    handleToggle,
    handleRemove,
    handleClear,
    // Sort
    toggleSort,
    currency,
  };
};

export default useCatalogState;
